export default __webpack_public_path__ + "static/media/5_1.e986b783.jpg";